export const InstagramFix = () => {
    const cleanURL = window.location.href.split('?')[0];


    const hash = cleanURL.split('#')[1];


    if (hash === 'ebook') {
        const element = document.getElementById(hash);
        if (element) {
            element.scrollIntoView();
        }


        window.history.replaceState({}, document.title, cleanURL);
    }
}